module.exports = ".sub-title {\r\n  border-bottom: 2px solid cornflowerblue;\r\n  padding: 20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/clubprogram-reports/components/dispute-report-search/dispute-report-search.component.css
// module id = ./src/app/shared/clubprogram-reports/components/dispute-report-search/dispute-report-search.component.css
// module chunks = main